import { TableCell } from 'shared/types/models/EditMetrics';

import { stylesRatioCell } from '../../../constants';

export function updateRatioColumnsStyles(cells: TableCell[][], columnsIndexes: number[]): TableCell[][] {
  return cells.map(row => {
    return row.map<TableCell>((cell, index) => columnsIndexes.includes(index)
      ? ({ ...cell, style: stylesRatioCell })
      : cell
    );
  });
}
